import React from 'react';
import {
  Button,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface OrderUpdateFormProps {
  defaultOrder: number;
  onSubmit: (data: { order: number }) => void;
}

interface FormData {
  order: number;
}

const validationSchema = yup.object().shape({
  order: yup.number().positive().typeError('Wrong order').required('Order is required'),
});

const OrderUpdateForm: React.FC<OrderUpdateFormProps> = ({
  defaultOrder,
  onSubmit,
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      order: defaultOrder,
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl size="small" sx={{ m: 1, width: { xs: '100%', sm: 180 } }} variant="outlined">
        <OutlinedInput
          {...register('order')}
          sx={{ pr: 0.5 }}
          id="order"
          endAdornment={
            <InputAdornment position="end">
              <Button type="submit" size="small" variant="contained">
                Save
              </Button>
            </InputAdornment>
          }
          placeholder="Order No"
          error={!!errors.order}
        />
      </FormControl>
      {errors.order && (
        <Typography variant="body2" color="error">
          {errors.order.message}
        </Typography>
      )}
    </form>
  );
};

export default OrderUpdateForm;
